// src/components/game/GameLog.js
import React, { useEffect, useRef } from 'react';

export const GameLog = React.memo(({ gameState }) => {
    const logContainerRef = useRef(null);

    useEffect(() => {
        if (logContainerRef.current) {
            logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
        }
    }, [gameState?.log]);

    if (!gameState) return null;

    return (
        <div className="glass-panel rounded-xl p-3 flex flex-col border-opacity-20 shadow-xl flex-1 min-h-0 mt-2">
            <h3 className="text-slate-200 text-xs font-bold flex items-center gap-1.5 tracking-wide uppercase border-b border-slate-700/50 pb-2 mb-2">
                <span className="text-sm">📜</span> GÜNLÜK
            </h3>
            <div ref={logContainerRef} className="flex-1 overflow-y-auto space-y-1 custom-scrollbar pr-1 bg-slate-950/30 rounded-lg p-2 border border-slate-700/30">
                {gameState.log?.map((entry, i) => (
                    <div key={i} className="text-[10px] text-slate-300 font-mono leading-relaxed break-words">
                        <span className="text-slate-600 mr-1">[{i + 1}]</span>
                        {entry}
                    </div>
                ))}
                {gameState.log?.length === 0 && (
                    <div className="text-center text-slate-600 text-[10px] italic mt-2">Henüz işlem yok...</div>
                )}
            </div>
        </div>
    );
});